// extracted by mini-css-extract-plugin
export default {"standalone_number_metric":"standalone_number_metric_standalone_number_metric__Qjkk9","unit":"standalone_number_metric_unit__QDBy-"};